import Label from 'uikit/labels/Labels/Labels';
import React from 'react';
import ReactDOM from 'react-dom';
import './Loader.scss';

/**
 * Loader: To show loader with or without label
 *
 * Example:
 *
 * <Loader label='Saving import' />
 * <Loader usePortal /> // For full screen coverage in fixed positioned containers
 *
 */

type Props = {
    label?: string;
    usePortal?: boolean; // When true, renders at document.body level for full screen coverage
};

export const Loader: React.FC<Props> = (props) => {
    const { label, usePortal = true } = props;

    const loaderContent = (
        <div className="loader-container">
            <div className="loader">
                <svg
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle
                        opacity="1"
                        cx="8"
                        cy="8"
                        r="7"
                        stroke="#ddd"
                        strokeWidth="2"
                    />
                    <path
                        d="M12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85651 14.2625 11.637 12.9497 12.9497"
                        stroke="white"
                        strokeWidth="2"
                        fill="transparent"
                    />
                </svg>
                {label && <Label variant="default" label={label} />}
            </div>
        </div>
    );

    // Use portal when usePortal is true to render at document.body level
    if (usePortal) {
        return ReactDOM.createPortal(loaderContent, document.body);
    }

    return loaderContent;
};
